// how-it-works/scale.js
//
// Progressive enhancement for the "scale journey" figure in the stimulus
// model section (titin -> cell -> fibre -> muscle+nerve). The base markup
// in how-it-works/index.html (.scale-journey-track > .stage-block, four of
// them, each a complete <svg> figure + copy block) is a fully readable,
// fully functional static sequence with no JS involved. This file does not
// add content; it only repositions the SAME dom nodes (no cloning) into a
// pinned, scroll-scrubbed zoom when:
//   - prefers-reduced-motion is not set,
//   - the viewport is >= 780px (mobile stays static per spec),
//   - and both gsap + ScrollTrigger loaded from the CDN.
// If any of those fail, this file simply does nothing further and the
// static stacked layout already on the page is the whole experience.

(function () {
  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function init() {
    if (prefersReducedMotion()) return;
    if (window.innerWidth < 780) return;

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) return;

    var section = document.querySelector('[data-scale-journey]');
    var track = section && section.querySelector('[data-scale-track]');
    if (!section || !track) return;

    var blocks = Array.prototype.slice.call(track.querySelectorAll('.stage-block'));
    if (blocks.length < 4) return;

    var figures = [];
    var copies = [];
    blocks.forEach(function (block) {
      var figure = block.querySelector('.stage-figure');
      var copy = block.querySelector('.stage-copy');
      if (figure) figures.push(figure);
      if (copy) copies.push(copy);
    });
    if (figures.length < 4 || copies.length < 4) return;

    gsap.registerPlugin(ScrollTrigger);

    // Build the pin scaffold and move the existing figure/copy nodes into
    // it (appendChild moves, it does not duplicate them), then drop the
    // now-empty stage-block wrappers. Semantics/reading order for anyone
    // without JS never involved this scaffold in the first place.
    var pin = document.createElement('div');
    pin.className = 'scale-pin';

    var inner = document.createElement('div');
    inner.className = 'scale-pin-inner';

    var figureStack = document.createElement('div');
    figureStack.className = 'scale-figure-stack';

    var copyStack = document.createElement('div');
    copyStack.className = 'scale-copy-stack';

    figures.forEach(function (figure) { figureStack.appendChild(figure); });
    copies.forEach(function (copy) { copyStack.appendChild(copy); });

    inner.appendChild(figureStack);
    inner.appendChild(copyStack);
    pin.appendChild(inner);

    blocks.forEach(function (block) { block.remove(); });
    track.appendChild(pin);
    section.setAttribute('data-enhanced', '');

    // Stage 1 is the "closest" zoom (a single protein); each later stage
    // starts slightly larger and eases down to 1, which is what reads as
    // the camera pulling back through scale levels as you scroll.
    gsap.set(figures, { opacity: 0, scale: 1.16 });
    gsap.set(figures[0], { opacity: 1, scale: 1 });
    gsap.set(copies, { opacity: 0, y: 14 });
    gsap.set(copies[0], { opacity: 1, y: 0 });

    var HOLD = 1; // time spent reading a stage before the next transition
    var MOVE = 0.6; // time spent crossfading between two stages

    var tl = gsap.timeline({
      defaults: { ease: 'power1.inOut' },
      scrollTrigger: {
        trigger: pin,
        start: 'top top',
        end: function () {
          return '+=' + Math.round(window.innerHeight * 3.5);
        },
        scrub: 0.6,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      },
    });

    tl.to({}, { duration: HOLD }); // hold on stage 1

    for (var i = 0; i < figures.length - 1; i++) {
      var label = 'move' + i;
      tl.addLabel(label)
        .to(figures[i], { opacity: 0, scale: 0.82, duration: MOVE }, label)
        .fromTo(
          figures[i + 1],
          { opacity: 0, scale: 1.16 },
          { opacity: 1, scale: 1, duration: MOVE },
          label
        )
        .to(copies[i], { opacity: 0, y: -14, duration: MOVE * 0.8, ease: 'power1.in' }, label)
        .fromTo(
          copies[i + 1],
          { opacity: 0, y: 14 },
          { opacity: 1, y: 0, duration: MOVE * 0.8, ease: 'power1.out' },
          label + '+=' + MOVE * 0.2
        )
        .to({}, { duration: HOLD }); // hold on stage i + 1
    }

    window.addEventListener('load', function () {
      ScrollTrigger.refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
